import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'tx-download-document',
  templateUrl: './download-document.component.html',
  styleUrls: ['./download-document.component.scss'],
})
export class DownloadDocumentComponent {
  @Input() isPdf: boolean = false;
  @Output() downloadDocument: EventEmitter<boolean> = new EventEmitter<boolean>();

  onDownloadClicked(downloadAsPdf: boolean) {
    this.downloadDocument.emit(downloadAsPdf);
  }
}

